<template>
  <!-- 全部订单 -->
  <div class="blankBox allOrders">
    <!-- 查询模块 -->
    <div class="searchBox">
      <table border="0" cellpadding="0" cellspacing="0" class="selectTb serchFilter" style="padding-left: 0;padding-top: 15px;">
        <tr>
          <td class="td1">
            {{ $t("loan.applyCompany") + ":" }}
          </td>
          <td class="td2">
            <el-input
              v-model.trim="criteria.company"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
              class="theme-gray"
              style="width:250px;"
              clearable
            />
          </td>
          <td class="td3">{{ $t("financingFundList.applyStatus") }}：</td>
          <td class="td4">
            <el-select
              v-model="criteria.status"
              :placeholder="$t('frontPage.pleaseChoose')"
              multiple
              class="theme-gray selectStatus"
              style="width:250px;"
            >
              <el-option
                v-for="(item, index) in statusData"
                :key="index"
                :label="$t(`allorders_status.${item}`)"
                :value="item"
              />
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="td1">
            {{ $t("financing.startTime") + ":" }}
          </td>
          <td class="td2">
            <el-date-picker
              v-model="startTime"
              :placeholder="$t('loan.selectTime')"
              class="theme-gray"
              style="width:250px;"
              format="yyyy-MM-dd"
              type="date"
            />
          </td>
          <td class="td3">
            {{ $t("financing.endTime") + ":" }}
          </td>
          <td class="td4">
            <el-date-picker
              v-model="endTime"
              :placeholder="$t('loan.selectTime')"
              class="theme-gray"
              style="width:250px;"
              format="yyyy-MM-dd"
              type="date"
            />
          </td>
        </tr>
        <tr>
          <td class="td1">
            {{ $t("flowLists.flowNumber") }}：
          </td>
          <td class="td2">
            <el-input
              v-model.trim="criteria.serialNumber"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
              class="theme-gray"
              style="width:250px;"
              clearable
            />
          </td>
          <td class="td3"/>
          <td class="td4"/>
        </tr>
      </table>
      <div class="text-center" style="margin: 10px auto 30px auto;">
        <!-- 查询按钮 -->
        <el-button class="queryBtn" @click.native="getList(1)">{{
          $t("btns.query")
        }}</el-button>
        <!-- 导出链接按钮 -->
        <!-- <a
          style="text-decoration: none;color: #7996F5;"
          class="exportBtn"
          :href="
            `${axios.defaults.baseURL}` +
              '/api/zmaExcel/exportFinancingExcel?' +
              $utils.urlencode({
                l_c: $localStorage.get('languageCode') || 'zh_cn',
                c_n: criteria.company,
                s_t: s_t,
                e_t: e_t,
                s_l: criteria.statusStr,
                f_l: criteria.serialNumber,
                token:getToken()
              })
          "
        >{{ $t("allorders.export") }}</a> -->
      </div>
    </div>
    <!-- 全部订单列表部分 -->

    <el-table :data="dataList" class="dataTable">
      <el-table-column :label="$t('contractManage.orderNum')" width="50" align="left">
        <template slot-scope="scope">
          <span>{{ ((page.pageNo-1) * page.rows) + scope.$index+1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.applyDate')" width="125">
        <template slot-scope="scope">{{ scope.row.applyTime | dateConvert }}</template>
      </el-table-column>
      <!--      申请日期-->

      <el-table-column :label="$t('flowLists.flowNumber')" prop="flowNumber" width="160"/>
      <el-table-column :label="$t('loan.applyCompany')" :show-overflow-tooltip="true" prop="applyCompany" width="170"/>
      <el-table-column :label="$t('financingFundList.applyMoneyTr')" width="150">
        <template slot-scope="scope">{{ scope.row.applyMoneyType }} {{ scope.row.applyMoney | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('poolOfMoney_page.lockMoney')+'(US$)'" width="170">
        <template slot-scope="scope">
          {{ scope.row.lockMoney | formatNum }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('loan.loanAmountList')+'(US$)'" width="160">
        <template slot-scope="scope">{{ scope.row.financingMoney | formatNum }}</template>
      </el-table-column>

      <!-- 申请状态 -->
      <el-table-column :label="$t('loan.status')" width="240" align="left" fixed="right">
        <template v-if="scope.row.applicationStatusList.length" slot-scope="scope">

          <p v-for="(statusItem,index) in scope.row.applicationStatusList" v-if="[100,101,1001,1002].indexOf(statusItem.status)==-1" :key="index" class="item">

            <template v-if="statusItem.loanType==1">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">{{ $t('newrisk.s_ship_data')+ v.sort }}</div>
            </template>
            <template v-if="statusItem.loanType==2">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
            </template>
            <template v-if="statusItem.loanType==3">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">NO{{ v.sort }}{{ $t(`allorders_status.${v.status}`) }}</div>
            </template>
            <template v-if="!statusItem.loanType">
              {{ $t(`allorders_status.${statusItem.status}`) }}
            </template>

          </p>
        </template>
      </el-table-column>
      <!-- 功能 -->
      <el-table-column :label="$t('contractManage.function')" align="center" fixed="right">
        <template v-if="scope.row.applicationStatusList.length" slot-scope="scope">
          <span>
            <!-- 跳胡蕾的详情页 -->
            <router-link
              v-if="[
                102,
                103,
                104,
                105,
                106,
                107,
                108,
                109,
                110,
                111,
                113,
                120,
                140,
                150,
                160,
                170,
                180,
                1001,
                1002,
                1003,
                1004,
                1005,
                1006,
                1007,
                1008,
                1009,
                1010,
                1011,
                1012,
                1013,
                1031,
                1099,
                1090,
                1091,
                1092,
                1093,
                1098,
              ].indexOf(scope.row.applicationStatusList[0].status) > -1"
              :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=6`"
              class="spanRouter"
            >{{ $t("btns.view") }}</router-link>
            <!-- 跳朱婉的详情页 -->
            <router-link
              v-if="[1, 3, 4, 5, 6, 7, 8].indexOf(scope.row.applicationStatusList[0].status) > -1"
              :to="`/rongzisqs?id=${scope.row.flowNumber}&menuType=1`"
              class="spanRouter"
            >{{ $t("btns.view") }}</router-link>
            <!-- 跳陈亮-资金锁定详情 -->
            <router-link
              v-if="
                [10, 11, 12, 13, 14, 300].indexOf(
                  scope.row.applicationStatusList[0].status
                ) > -1
              "
              :to="
                `/financingFundDetail?in_id=${scope.row.flowNumber}&menuType=6`
              "
              class="spanRouter"
            >{{ $t("btns.view") }}</router-link>
            <!-- 跳陈亮-贸易合同详情 -->
            <router-link
              v-if="
                [15, 17, 18, 19, 20, 21, 22].indexOf(
                  scope.row.applicationStatusList[0].status
                ) > -1
              "
              :to="
                `/financingExamineDetail?in_id=${scope.row.flowNumber}&menuType=6`
              "
              class="spanRouter"
            >{{ $t("btns.view") }}</router-link>
          </span>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="statusEmpty"><i/>{{ $t('financing.noData') }}</div>
      </template>
    </el-table>
    <el-pagination
      v-show="page.total"
      :total="page.total"
      :page-size="page.rows"
      :current-page.sync="page.pageNo"
      class="page-theme"
      background
      layout="prev, pager, next"
      style="text-align: center;padding-top:30px; padding-bottom: 30px; "
      @current-change="getList(page.pageNo)"/>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import mixins from '@/helper/mixins.js'
import Tbutton from '../../components/Tbutton'
export default {
  name: 'AllOrders',
  components: {
    Tbutton
  },
  mixins: [mixins],
  data() {
    return {
      criteria: {
        company: '',
        serialNumber: '',
        status: [],
        statusStr: ''
      },
      startTime: dayjs(dayjs().subtract(12, 'month').format('YYYY-MM-DD') + ' 00:00:00').toDate(),
      endTime: dayjs(dayjs().format('YYYY-MM-DD') + ' 23:59:59').toDate(),
      s_t: '',
      e_t: '',

      // 申请状态列表数据
      statusData: [0, 1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 300, 13, 14, 15, 17, 18, 19, 20, 21, 22, 102, 103, 104, 105, 106, 108, 111, 120, 140, 150, 160, 170, 1003, 1004, 1005, 1006, 1007, 1009, 1011, 1012, 1013, 1099, 180], // 去掉 ,109,110,113,
      time: '',
      dataList: [],
      page: {
        pageNo: 1, // 当前页数
        rows: 10,
        total: 0
      }, // 分页数据

      // 当前页码
      // pg_st: 1,
      // total: 0,
      ifIsSuper: ''
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  created() {
    this.isSuper()
    this.getMenuInfo()
    this.getList(1)
    // this.getSysDict();
    this.getMenu()
    this.checkSort()
  },
  mounted() {
    document.title = this.$t('poolOfMoney_page.allorders')
  },
  methods: {
    // 判斷是否管理員
    isSuper() {
      this.ifIsSuper = parseInt(this.$utils.getStorage('userProfile').isSuper)
    },
    getMenuInfo() {
      // 如果是管理员不用验证，所有权限都有，不是admin，验证权限，没有权限退出登录
      if (this.ifIsSuper == 1) {
        return
      } else {
        this.axios
          .post('/api/zma/loanMenu/getMenuInfo', { t_y: 6 })
          .then(res => {
            if (res.status) {
              if (res.data.optTypeList.indexOf(1) > -1) {
                return
              } else {
                this.$router.push('/')
              }
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              )
            }
          })
      }
    },
    /**
     * 获取系统数据字典
     */
    // getSysDict() {
    //   this.axios
    //     .get("/static/sysDict/sysDictValue.json")
    //     .then(res => {
    //       if (res.all_order_status) {
    //         // this.statusData = res.all_order_status.en;
    //         this.statusData = [0,4,5,6,7,8, 10,11,12,300,13,14,15, 17,18,19,20,21,22, 102,103,104,105,106,108,109,110,111,113, 120,140,150,160,170,180]
    //       }
    //     })
    //     .catch(err => {
    //       this.$message.error(this.$t(`frontPage.${err.errorCode}`));
    //     });
    // },

    getList(pg_st) {
      this.page.pageNo = pg_st
      this.s_t = dayjs(this.startTime)
        .format('YYYY-MM-DD')
        .toString()
      this.e_t = dayjs(this.endTime)
        .format('YYYY-MM-DD')
        .toString()
      this.criteria.statusStr = this.criteria.status.join(',')
      const params = {
        c_n: this.criteria.company,
        s_l: this.criteria.statusStr,
        f_l: this.criteria.serialNumber,
        pg_st: pg_st,
        pg_rs: 10
      }
      if (this.startTime) {
        params.s_t = this.startTime.toString()
      }
      if (this.endTime) {
        params.e_t = dayjs(dayjs(this.endTime).format('YYYY-MM-DD') + '23:59:59').toDate().toString()
      }
      this.axios.post('/api/zma/financing/list', params).then(res => {
        if (res.status) {
          this.page.total = res.data.total
          this.dataList = res.data.rows
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`))
        }
      })
    },
    checkSort(sort) {
      if (sort) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss">
@import "../PoolOfMoney/poolOfMoneyDialog/elDialogChange.scss";
</style>
<style lang="scss" scoped>
.allOrders {
  font-size: 14px;
  .searchBox {
    .queryBtn {
      display: inline-block;
      width: 150px;
      height: 38px;
      background: #7996f5;
      border-radius: 2px;
      color: #fff;
    }
    .exportBtn {
      display: inline-block;
      width: 148px;
      height: 36px;
      margin-left: 20px;
      background: #ffffff;
      border: 1px solid #7996f5;
      border-radius: 2px;
      text-align: center;
      line-height: 38px;
    }
  }
  .searchBox {
    .selectTb{
      table-layout:fixed;
      td{
        font-size: 14px;
        color: #333333;
        height: 40px;
        line-height: 40px;
        padding:10px 30px;
        &.td2{
          padding-right: 10px;
          padding-left: 0;
        }
        &.td4{
          padding-left: 0;
        }
      }
    }
  }

}
</style>
